import script from "./gallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./gallery.vue?vue&type=script&setup=true&lang=ts"

import "./gallery.vue?vue&type=style&index=0&id=cee40b14&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cee40b14"]])

export default __exports__